import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'

export const DefaultInfo = () => (
    <Text variant="bodySmall" color="grayscale_800" mb={24}>
        <FormattedMessage
            id="tickets.config.section_description"
            defaultMessage="Kupuj bilety online, aby mieć gwarancję wejścia i korzystać z dedykowanych kas szybkiej obsługi."
        />
    </Text>
)
